import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';

export const SVFlagIcon: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <circle cx="10" cy="10" r="8.88889" fill="#0052B5" />
      <mask
        id="mask0_sv_flag"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="1"
        y="1"
        width="18"
        height="18"
      >
        <circle cx="10" cy="10" r="8.88889" fill="#FCFCFC" />
      </mask>
      <g mask="url(#mask0_sv_flag)">
        <rect
          x="1.11111"
          y="1.11111"
          width="17.7778"
          height="17.7778"
          fill="#0052B5"
        />
        <rect
          x="5.55556"
          y="1.11111"
          width="3.55556"
          height="17.7778"
          fill="#FFDB44"
        />
        <rect
          x="1.11111"
          y="8.22222"
          width="17.7778"
          height="3.55556"
          fill="#FFDB44"
        />
      </g>
    </BaseIcon>
  );
};

SVFlagIcon.displayName = 'SVFlagIcon';
